const geoRoutes = [
  {
    path: "/geo/traffic-list",
    name: "geo-traffic-list",
    component: () => import("@/views/geo/TrafficListV2.vue"),
    meta: {
      layout: "content",
      resource: "geo_traffic_list",
      action: "manage",
    },
  },
  {
    path: "/geo/traffic-list-v2",
    redirect: { name: "geo-traffic-list" },
  },
  {
    path: "/geo/traffic-list-v1",
    name: "geo-traffic-list-v1",
    component: () => import("@/views/geo/TrafficList.vue"),
    meta: {
      layout: "content",
      resource: "geo_traffic_list",
      action: "manage",
      navActiveLink: "geo-traffic-list",
    },
  },
  {
    path: "/geo/:pathMatch(.*)*",
    redirect: { name: "geo-traffic-list" },
  },
];

export default geoRoutes;
